'use client';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import {mediaFromWire, type OverviewWireSection} from '../../model';
import {RichContent} from '../article';
import {Section} from '../primitives';
import {EyebrowHeading} from './EyebrowHeading';
import {OVERVIEW_ASPECT, SectionMedia} from './SectionMedia';

export interface AboutOverviewSectionProps {
  title: string;
  overview: OverviewWireSection['overview'];
  sectionId?: string;
}

export function AboutOverviewSection({title, overview, sectionId}: AboutOverviewSectionProps) {
  const media = mediaFromWire(overview?.media);
  const eyebrow = overview?.displayLabel;
  const description = overview?.description;
  if (!media || !title || !description) {
    return null;
  }
  return (
    <Section tone="raised" sx={{paddingBlock: {xs: 4, md: 9}}}>
      <Container>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {xs: '1fr', md: '570fr 422fr'},
            gridTemplateAreas: {xs: '"head" "media" "copy"', md: '"media ." "media head" "media copy" "media ."'},
            gridTemplateRows: {md: '1fr auto auto 1fr'},
            columnGap: 13,
            rowGap: 2.5,
            alignItems: {md: 'center'},
          }}
        >
          <Box sx={{gridArea: 'media', alignSelf: 'center', width: '100%'}}>
            <SectionMedia
              media={media}
              alt={media.alt ?? title}
              aspectRatio={OVERVIEW_ASPECT}
              elevated
              accent
              sectionName={title}
              sectionId={sectionId}
            />
          </Box>
          <Box sx={{gridArea: 'head'}}>
            <EyebrowHeading eyebrow={eyebrow} title={title} />
          </Box>
          <Box sx={{gridArea: 'copy'}}>
            <RichContent html={description} collapsible={false} sx={{color: theme => theme.palette.colors.text.neutral.default}} />
          </Box>
        </Box>
      </Container>
    </Section>
  );
}

AboutOverviewSection.displayName = 'AboutOverviewSection';
